<script setup>

</script>
<template>
<i>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M18.909 17.0909C18.909 17.4767 18.7557 17.8466 18.483 18.1194C18.2102 18.3922 17.8402 18.5455 17.4544 18.5455H5.81807C5.4323 18.5455 5.06233 18.3922 4.78955 18.1194C4.51677 17.8466 4.36353 17.4767 4.36353 17.0909V6.90909C4.36353 6.52332 4.51677 6.15335 4.78955 5.88057C5.06233 5.60779 5.4323 5.45454 5.81807 5.45454H9.45443L10.909 7.63636H17.4544C17.8402 7.63636 18.2102 7.78961 18.483 8.06239C18.7557 8.33517 18.909 8.70514 18.909 9.09091V17.0909Z" fill="#F9FAFB" stroke="#B0B0B0" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6.82272 12.0355L4.47307 17.1264C4.16724 17.789 4.65123 18.5455 5.38103 18.5455H17.9056C18.2956 18.5455 18.6501 18.3187 18.8135 17.9645L21.1632 12.8736C21.469 12.211 20.985 11.4545 20.2552 11.4545H7.73067C7.34062 11.4545 6.98617 11.6813 6.82272 12.0355Z" fill="#F9FAFB" stroke="#B0B0B0" stroke-width="1.4"/>
  </svg>
</i>
</template>
<style scoped>

</style>